import { useCallback, useEffect, useRef, useState } from 'react'

const useBackBtn = () => {
  const [initHistorySize, setInitHistorySize] = useState(0)
  const [delta, setDelta] = useState(0)

  const initialURL = useRef(location.pathname)
  const timout = useRef<NodeJS.Timeout | undefined>(undefined)

  useEffect(() => {
    setInitHistorySize(window.history.length)
    return () => {
      if (timout.current) clearTimeout(timout.current)
    }
  }, [])

  // Push state is required to trigger popstate after each iframe redirect
  const pushState = () => {
    const state = { iframeRedirectUrlChanged: true }
    history.pushState(state, '', location.pathname)
  }

  const goDeltaBack = useCallback(() => {
    window.removeEventListener('popstate', goDeltaBack)

    // Go back by the specified number of steps
    if (delta > 0) {
      history.go(-delta)
    }

    // By using history.go we won't receive a separate
    // event specifically indicating that the URL has changed.
    // To detect a URL change after calling history.go
    // we need to add a delay before checking the URL
    // to give the browser enough time to update the state.
    timout.current = setTimeout(function () {
      // Check the current URL after the delay
      if (location.pathname !== initialURL.current) {
        // We need to do the reload due to the fact that in some cases
        // Only a shallow redirect happens
        location.reload()
      }
    }, 100)
  }, [delta])

  const frameRedirected = useCallback(() => {
    pushState()
    setDelta(window.history.length - initHistorySize)
  }, [initHistorySize])

  useEffect(() => {
    window.addEventListener('popstate', goDeltaBack)
    return () => {
      window.removeEventListener('popstate', goDeltaBack)
    }
  }, [goDeltaBack])

  return frameRedirected
}

export default useBackBtn
